var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"site"},[_c('main',{staticClass:"accept-terms"},[_c('div',{staticClass:"-full-height",style:({
        backgroundImage: 'url(' + require('@/assets/graphics/accept-terms-bg.jpg') + ')',
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
      })}),_c('AcceptTermsForm')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }